// extracted by extract-css-chunks-webpack-plugin
module.exports = {"college":"college_ZE+eH","title":"title_mEvTV","content":"content_2dGoh"};